import { joinList as fallback } from 'd2/utils/StringHelpers'

export function getBrowserLanguage (): string | null | undefined {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (navigator.languages !== undefined) return navigator.language
}

export function joinList (list: string[]): string {
  try {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const lf = new Intl.ListFormat(getBrowserLanguage() || 'en')
    return lf.format(list)
  } catch {
    return fallback(list)
  }
}
